import { render, staticRenderFns } from "./CredenciamentoVisualizacaoLotesItens.vue?vue&type=template&id=61a131a2&scoped=true&"
import script from "./CredenciamentoVisualizacaoLotesItens.vue?vue&type=script&lang=js&"
export * from "./CredenciamentoVisualizacaoLotesItens.vue?vue&type=script&lang=js&"
import style0 from "./CredenciamentoVisualizacaoLotesItens.vue?vue&type=style&index=0&id=61a131a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a131a2",
  null
  
)

export default component.exports